import { render, staticRenderFns } from "./BusInspectionBaseList.vue?vue&type=template&id=b6b2d476&scoped=true&"
import script from "./BusInspectionBaseList.vue?vue&type=script&lang=js&"
export * from "./BusInspectionBaseList.vue?vue&type=script&lang=js&"
import style0 from "./BusInspectionBaseList.vue?vue&type=style&index=0&id=b6b2d476&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6b2d476",
  null
  
)

export default component.exports